import React, { useEffect, useState } from "react";
import MobileLayout from "../MobileLayout";
import { HomeCard } from "./HomeCard";
import Logo from "../asset/logo/LOGO_ORANGE.svg";
import frame1 from "../asset/home-section/frame1.png";
import frame2 from "../asset/home-section/frame2.png";
import {
  AppBar,
  Toolbar,
  IconButton,
  Avatar,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
} from "@material-ui/core";
import { Menu as MenuIcon, Close as CloseIcon } from "@material-ui/icons";
import profilePic from "../asset/characters/profile.png";
import "./home2.css";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
// import { getUserRank } from "./services";
import { useTranslation } from "react-i18next";
import analytics from "../analytics/track";
import { getPersonalScoreByUserId } from "../apis/UserApis";
import { LevelCard } from "../game/LevelCard";
import { getMyResult, MyResult } from "../apis/BreefApis";
import { getLevels } from "../services/breefGameService";

interface PendingBreef {
  breefName: string;
  expiry: string; // Assuming it's a string representation of a date
  gameId: {
    gameName: string;
    categoryId: string;
    gameCode: string;
    id: string;
  };
  id: string;
  questions: any[]; // Define the actual type of questions if possible
  status: string;
  tenantId: {
    status: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    // Add more properties as needed
  };
  videoUrl: string;
}
export const HomeSection2 = () => {
  const [t, i18n] = useTranslation("global");
  const [loading, setLoading] = useState(true);
  const [mine, setMine] = useState<MyResult | null>(null);
  const smFname = useSelector((state: RootState) => state.onboard.firstname);
  const smLname = useSelector((state: RootState) => state.onboard.lastname);
  const smEmail = useSelector((state: RootState) => state.onboard.email);
  const smPhone = useSelector((state: RootState) => state.onboard.phone);
  const smUserID = useSelector((state: RootState) => state.onboard.userID);
  const [totalScore, setTotalScore] = useState(0);
  const userId = sessionStorage.getItem("userId");
  const quizScore = Number(sessionStorage.getItem("quizScore")) | 0;
  const breefScore = Number(sessionStorage.getItem("gameScore")) | 0;

  const [isTracked, setIsTracked] = useState(false);


  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const score = parseInt(sessionStorage.getItem("totalScore") || '0')
  useEffect(() => {
    if (score > 0) {
      console.log("Total Score:", score);
      setTotalScore(score);
      fetchRankImage(score);
    }
    if (!isTracked) {
      analytics.track("Dashboard Viewed", {
        current_page: "dashboard",
      });
      console.log("Dashboard Viewed");

      setIsTracked(true);
    }
    fetchTotalScoreById();
  }, [isTracked]);

  const fetchTotalScoreById = async () => {
    try {
      const totalScore = await getPersonalScoreByUserId();
      setTotalScore(totalScore.totalScore);
      sessionStorage.setItem("totalScore", totalScore.totalScore.toString());
      console.log("Total Score:", totalScore);
      await fetchRankImage(parseInt(totalScore.totalScore));
    } catch (error) {
      console.error("Error fetching total score:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchRankImage = async (_totalScore: number) => {
    // The level with its heading, name and picture comes from the server (admin → Levels)
    setMine(await getMyResult().catch(() => null));
  };
  const handleHomeCardClick = () => {
    console.log("Home Card Clicked");
    navigate("/breefInvite");
  };
  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      (event as React.KeyboardEvent).type === "keydown" &&
      ((event as React.KeyboardEvent).key === "Tab" ||
        (event as React.KeyboardEvent).key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  // const handleLogout = () => {
  //   signout(); // Call the signout service

  //   analytics.reset();

  //   navigate("/sign-in"); // Redirect to the login page
  // };

  const drawerList = () => (
    <div
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
      className="drawer-list"
    >
      <List>
        <ListItem>
          <IconButton onClick={toggleDrawer(false)} style={{ marginLeft: "auto" }}>
            <CloseIcon />
          </IconButton>
        </ListItem>
        <ListItem
          button
          onClick={() => {
            navigate("/home");
          }}
        >
          <ListItemText primary={t("drawer.home")} />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            analytics.track("My profile clicked", {
              current_page: "dashboard",
            });
            navigate("/profile");
          }}
        >
          <ListItemText primary={t("drawer.profile")} />
        </ListItem>
        <ListItem button>
          <ListItemText primary={t("drawer.settings")} />
        </ListItem>
        {/* <ListItem button onClick={handleLogout}>
          <ListItemText primary={t("drawer.logout")} />
        </ListItem> */}
      </List>
    </div>
  );
  //   const [rank, setRank] = useState("");
  //   const [perc, setPerc] = useState("");

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const resp = await getUserRank();
  //     console.log("resp of rank: ", resp);

  //     // console.log("rank: ", resp.rank, "perc: ", resp.perc);
  //     //   setRank(resp.rank);
  //     //   setPerc(resp.perc);
  //   };
  //   fetchData();
  // }, []);

  return (
    <MobileLayout>
      <div style={{
        display: "flex",
        flexDirection: "column",
        height: "100dvh",
        width: "100%",
        overflow: "hidden"
      }}>
        <AppBar
          position="relative"
          style={{
            backgroundColor: "transparent",
            boxShadow: "none",
            backdropFilter: "blur(10px)",
            flexShrink: 0
          }}
        >
          <Toolbar style={{ justifyContent: "space-between" }}>
            {/* <IconButton
              edge="start"
              color="primary"
              aria-label="menu"
              style={{ marginRight: "10px" }}
              onClick={toggleDrawer(true)}
            >
              <MenuIcon style={{ color: "#000", fontSize: "2rem" }} />
            </IconButton> */}
            <img src={Logo} alt="Logo" style={{ height: '100px', margin: '0 auto' }} />
            {/* <Avatar
              alt="Profile"
              src={profilePic}
              style={{ marginLeft: "auto", cursor: "pointer" }}
              onClick={() => {
                analytics.track("My profile clicked", {
                  current_page: "dashboard",
                });
                navigate("/profile");
              }}
            /> */}
          </Toolbar>
        </AppBar>

        {!loading ? (
          <>
            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
              {drawerList()}
            </Drawer>
            <LevelCard level={mine?.level || null}>
              <p className="result-score">{totalScore}</p>
            </LevelCard>

            {/* <div className="home-container2">
              <img src={rankImage.imageUrl|| ""} alt="Background" className="bg-image" />
              <div className="centered-text">{totalScore}</div>
            </div> */}
          </>
        ) : (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", fontFamily: "Roboto", color: "#666" }}>
            {t("gameResult.loading")}
          </div>
        )}
      </div>
    </MobileLayout>
  );
};
